<script setup>
import content from "./index-content.json";

const meta_tags = ref(content.meta_tags);
const features = ref(content.features);
const faq = ref(content.faq);
const cta = ref(content.cta);

definePageMeta({
  layout: "laravel-layout",
});

useHead({
  title: meta_tags.value.title,
  meta: meta_tags.value.meta,
});
const header = ref({
  heading: `Laravel Website Maintenance and Support Services`,
  text: `We handle everything related to your Laravel website or application including maintenance, security updates, backups, and technical support. You will have a dedicated contact person with whom you can discuss all your Laravel needs directly in your language.`,
  image: "/images/hero-wp-header.webp",
  width: "443",
  height: "429",
  image_safari_ext: "png",
});
</script>

<template>
  <section class="relative z-10">
    <div class="max-w-screen-xl mx-auto px-4">
      <div class="grid grid-cols-1 lg:grid-cols-2 items-center gap-8 py-16 max-sm:pt-4 relative">
        <!-- Text Content -->
        <div>
          <h1 class="leading-tight">
            <WrGradientText>
              Laravel Website Maintenance and Support Services
            </WrGradientText>
          </h1>
          <p class="mt-2 mb-4 text-lg !leading-[1.8] max-w-xl">
            We handle everything related to your Laravel website or application
            including maintenance, security updates, backups, and technical
            support. You will have a dedicated contact person with whom you can
            discuss all your Laravel needs directly in your language.
          </p>
        </div>

        <!-- Image -->
        <div class="relative">
          <NuxtImg src="/images/hero-wp-header.webp" width="565" height="352" alt="Laravel Maintenance Illustration"
            loading="lazy" format="webp" />
        </div>
      </div>
    </div>
  </section>

  <section class="py-6 lg:py-12 relative z-[30]">
    <div class="px-4 max-w-screen-xl mx-auto relative z-10">
      <h2 class="font-bold lg:text-center z-20 relative">
        <WrGradientText append-class="!leading-[1]">
          {{ content.features.main_heading }}
        </WrGradientText>
      </h2>
      <div v-html="content.features.sub_text" class="tracking-[0.5px] mb-14 mx-auto lg:px-20 text-lg lg:text-center">
      </div>
    </div>
    <WrListCards :cards="features?.services?.item" class="relative z-30" />
  </section>

  <WrBannerCTA :heading="cta.title" :button-text="cta.linkText" :paragraph-text="cta.subheading" />

  <section class="py-6 lg:py-12">
    <div class="px-4 max-w-screen-xl mx-auto">
      <h2 class="font-bold lg:text-center">
        <WrGradientText append-class="!leading-[1]">{{
          faq?.main_heading
        }}</WrGradientText>
      </h2>
      <div v-html="faq.sub_text" class="tracking-[0.5px] mb-14 mx-auto lg:px-20 text-lg lg:text-center"></div>
      <WrAccordion :Content="faq.content" />
      <div
        class="mt-6 bg-red-100/50 border-l-4 dark:border-white border-[#d50b00] dark:bg-[image:var(--bg-official-partner)] text-xs p-4 rounded lg:mx-4">
        <p>
          <strong>Disclaimer:</strong> Laravel and the Laravel logo are
          trademarks of Taylor Otwell. Copyright © 2011–2021
          <NuxtLink to="https://laravel.com" class="underline hover:no-underline">Laravel LLC</NuxtLink>, used under
          license agreement.
        </p>
      </div>
    </div>
  </section>

  <section class="relative z-10 pb-8">
    <div class="max-w-screen-xl mx-auto px-4">
      <h2 class="text-center">
        <WrGradientText text="Trusted for excellence and efficiency" />
        <p class="text-lg text-[var(--foreground)]">
          Webreinvent is trusted by leading organisations to enhance their
          development and operational efficiency.
        </p>
      </h2>
      <WrTestimonialCardCarousel class="mt-12" />
      <WrButton link="/testimonials" container-class="max-w-max mx-auto mt-7">View All</WrButton>
    </div>
  </section>
</template>
